"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  id: 1,
  quote: "City Pet Care provided exceptional support during our emergency. Their calm environment and expert team truly saved our golden retriever, Max.",
  name: "Sarah Jenkins",
  major: "Golden Retriever Parent",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_parent_sarah.png"
}, {
  id: 2,
  quote: "The online pharmacy is so convenient! I can order Bella's heartworm meds from my phone and they arrive right at our door in the city.",
  name: "David Chen",
  major: "Cat Dad",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_parent_david.png"
}, {
  id: 3,
  quote: "I love the modern, serene atmosphere. It's the first time my nervous rescue dog didn't shake during a check-up. Truly a urban oasis for pets.",
  name: "Emily Rodriguez",
  major: "Rescue Advocate",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_parent_emily.png"
}];
export default function VoicesOfPetParents() {
  return <section data-section-id="234219" id="voices-of-pet-parents" className="bg-background text-foreground py-24 sm:py-32 overflow-hidden relative">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-center items-center opacity-40">
        <div className="w-[800px] h-[400px] bg-chart-1/20 blur-[120px] rounded-lg" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                <div className="flex flex-col items-center justify-center p-4 sm:p-8">
                  <blockquote className="text-2xl md:text-3xl font-default italic text-center leading-relaxed text-foreground mb-10 max-w-4xl mx-auto tracking-tight">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
                    <div className="flex items-center gap-3">
                      <SafeHydrate><Avatar className="size-12 border-2 border-white shadow-md">
                        <AvatarImage src={testimonial.avatarUrl} alt={testimonial.name} />
                        <AvatarFallback className="bg-secondary text-secondary-foreground font-medium">
                          {testimonial.name.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="flex flex-col items-start">
                        <span className="font-semibold text-foreground text-sm font-default">
                          {testimonial.name}
                        </span>
                      </div>
                    </div>
                    
                    <div className="hidden sm:block w-px h-8 bg-border/60" />
                    
                    <Badge variant="secondary" className="rounded-lg px-3 py-1 text-xs font-medium bg-white/40 backdrop-blur-md border-border/50 shadow-sm text-muted-foreground">
                      {testimonial.major}
                    </Badge>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-3 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-white/80 backdrop-blur-sm hover:bg-white border-border/50 shadow-md size-10 rounded-lg" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-white/80 backdrop-blur-sm hover:bg-white border-border/50 shadow-md size-10 rounded-lg" />
          </div>
        </Carousel>
      </div>
    </section>;
}